var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWestfieldDirectSwooshinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0DD9CB",
  d: "m10.191 8 10.064 10.222c.477.483.745 1.138.745 1.822 0 .683-.268 1.339-.745 1.822L10.277 32H6.192l8.1-8.235a.89.89 0 0 0 0-1.248L0 8zm11.564-8 13.08 13.168a4.026 4.026 0 0 1 0 5.664L21.755 32H16.22l9.418-9.5a3.375 3.375 0 0 0 0-4.747L8 0z"
})));
export default SvgWestfieldDirectSwooshinline;